module.exports = __webpack_public_path__ + "static/media/PM102.d9c93dbf.png";